import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { initGA } from './utils/analytics'
import App from './App'
import './styles.css'
import './admin-recovery.css'

const gtmId = import.meta.env.VITE_GTM_ID || 'GTM-MPTF85KW'
if (typeof window !== 'undefined' && gtmId) {
  TagManager.initialize({ gtmId })
}
initGA()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

